export default "__VITE_ASSET__CH8_mv14__"